import { Link } from 'react-router';
import { Logo } from '@/components/brand/Logo.tsx';
import { Button } from '@/components/ui/Button.tsx';

export function NotFound() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-start justify-center px-6">
      <Logo className="text-2xl" />
      <p className="mt-8 text-sm font-medium tracking-wide text-muted-foreground uppercase">404</p>
      <h1 className="mt-2 text-3xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-3 text-base text-muted-foreground">
        The page you were looking for doesn&rsquo;t exist. It may have moved, or the link is out of
        date.
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/">
          <Button variant="primary">Go home</Button>
        </Link>
        <Link to="/login">
          <Button variant="secondary">Sign-in options</Button>
        </Link>
      </div>
    </main>
  );
}
